import mixpanel from "mixpanel-browser"
import { DIAGNOSES_EVENTS } from "."

interface CompleteDiagnosisProps {
  completionDate: string
  userName: string
  userEmail: string
  subthemeId: string
  score: number
}

export function completeDiagnosis(props: CompleteDiagnosisProps) {
  return mixpanel.track(DIAGNOSES_EVENTS.COMPLETE_DIAGNOSIS, {
    ...props,
  })
}
